import type { ApiConfig } from '@/providers/ApiConfigProvider';

export interface GraphQLResponse<T> {
  data?: T;
  errors?: Array<{ message: string; locations?: Array<{ line: number; column: number }>; path?: string[] }>;
}

export async function graphqlQuery<T>(
  apiConfig: Pick<ApiConfig, 'apiBaseUrl' | 'getHeaders'>,
  query: string,
  variables?: Record<string, unknown>,
  signal?: AbortSignal,
): Promise<T> {
  const url = `${apiConfig.apiBaseUrl}/graphql`;
  const headers = await apiConfig.getHeaders();

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`GraphQL request failed with status ${response.status}`);
  }

  const json: GraphQLResponse<T> = await response.json();

  if (json.errors?.length) {
    throw new Error(json.errors.map((x) => x.message).join('; '));
  }

  if (!json.data) {
    throw new Error('GraphQL response contained no data');
  }

  return json.data;
}
